// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"682":"global","797":"national"}[chunkId] || chunkId) + "." + {"227":"18642ab8","370":"170bf75b","479":"4d03c32b","682":"cfc269a0","797":"ed51cf62"}[chunkId] + ".css";
};